import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar } from './Sidebar';

/**
 * Admin sidebar — wraps the shared Sidebar with Admin Portal label
 * and a green role badge.
 */
export function AdminSidebar({ user, onLogout, onCollapseChange }) {
  return (
    <Sidebar
      user={user}
      onLogout={onLogout}
      portalLabel="Admin Portal"
      badgeBg="bg-green-500"
      onCollapseChange={onCollapseChange}
    />
  );
}

AdminSidebar.propTypes = {
  user: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
  onCollapseChange: PropTypes.func,
};
